"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var JobField_1 = __importDefault(require("@features/ItemCommon/components/common/JobField"));
function JobCustomerSpecific(_a) {
    var _b, _c;
    var scope = _a.scope, job = _a.job, updateCustomerSpecific = _a.updateCustomerSpecific, isNotEditable = _a.isNotEditable, domain = _a.domain, automationListsPermission = _a.automationListsPermission;
    var fields = ((_c = (_b = job === null || job === void 0 ? void 0 : job.ad) === null || _b === void 0 ? void 0 : _b.customerSpecific) === null || _c === void 0 ? void 0 : _c[scope]) || {};
    var arrayOfFields = fields && Object.keys(fields).map(function (key) { return ({ key: key, value: fields[key] }); });
    return (react_1.default.createElement(react_1.default.Fragment, null, arrayOfFields &&
        arrayOfFields.map(function (field) {
            var key = field.key, value = field.value;
            return (react_1.default.createElement(JobField_1.default, { key: key, label: key, value: value, setValue: function (value) { return updateCustomerSpecific(scope, key, value); }, isNotEditable: isNotEditable, domain: domain, labelClassName: "item-detail-field__label-customer-specific", automationListsPermission: automationListsPermission }));
        })));
}
exports.default = JobCustomerSpecific;
